import React from 'react';

interface PlayStoreBadgeEnProps {
  size: number;
}

const PlayStoreBadgeEn = ({ size = 36 }: PlayStoreBadgeEnProps) => {
  return (
    <svg width={size / 0.3} height={size} viewBox="0 0 61 18" fill="none">
      <g clipPath="url(#clip0_612_64902)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M58.7399 18H2.26009C1.01446 18 0 16.9855 0 15.75V2.25C0 1.00998 1.01446 0 2.26009 0H58.7399C59.9844 0 61 1.00998 61 2.25V15.75C61 16.9855 59.9844 18 58.7399 18Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M58.7399 0.360224C59.7847 0.360224 60.6398 1.20973 60.6398 2.25V15.75C60.6398 16.7903 59.7903 17.6398 58.7399 17.6398H2.26009C1.21533 17.6398 0.360223 16.7903 0.360223 15.75V2.25C0.360223 1.20973 1.20972 0.360224 2.26009 0.360224H58.7399ZM58.7399 0H2.26009C1.01446 0 0 1.01446 0 2.25V15.75C0 16.99 1.01446 18 2.26009 18H58.7399C59.9844 18 61 16.99 61 15.75V2.25C61 1.01446 59.9844 0 58.7399 0Z"
          fill="white"
        />
        <path
          d="M32.135 5.95428C31.7277 5.95428 31.3843 5.81177 31.1127 5.53122C30.8434 5.25852 30.693 4.88259 30.6998 4.4988C30.6998 4.0892 30.8389 3.74244 31.1127 3.4675C31.3832 3.18695 31.7266 3.04443 32.1339 3.04443C32.5368 3.04443 32.8802 3.18695 33.1562 3.4675C33.43 3.75142 33.5692 4.09817 33.5692 4.4988C33.5647 4.90952 33.4256 5.25628 33.1562 5.53009C32.8858 5.81289 32.5424 5.95428 32.135 5.95428ZM20.0143 5.95428C19.6159 5.95428 19.2702 5.81401 18.9875 5.53683C18.7069 5.26077 18.5644 4.91177 18.5644 4.49992C18.5644 4.08807 18.7069 3.73907 18.9875 3.46301C19.2646 3.18583 19.6103 3.04556 20.0143 3.04556C20.2118 3.04556 20.4037 3.08483 20.5877 3.16451C20.7684 3.24194 20.9154 3.34743 21.0242 3.47648L21.0512 3.50902L20.7471 3.80753L20.7156 3.77049C20.5439 3.56625 20.3139 3.46638 20.0098 3.46638C19.7382 3.46638 19.5014 3.56289 19.3062 3.75366C19.1098 3.94556 19.0099 4.19693 19.0099 4.50104C19.0099 4.80516 19.1098 5.05653 19.3062 5.24842C19.5014 5.4392 19.7382 5.53571 20.0098 5.53571C20.2993 5.53571 20.5428 5.4392 20.7325 5.24842C20.8447 5.1362 20.9143 4.9791 20.9389 4.78047H19.9638V4.36077H21.3575L21.3631 4.39892C21.3732 4.46962 21.3833 4.54256 21.3833 4.60989C21.3833 4.99705 21.2666 5.31014 21.0355 5.54132C20.7729 5.81513 20.4295 5.95428 20.0143 5.95428ZM36.13 5.89481H35.7002L34.3839 3.78845L34.3951 4.16775V5.89369H33.9653V3.10503H34.4557L34.4692 3.12635L35.707 5.11039L35.6957 4.73221V3.10503H36.13V5.89481ZM28.9054 5.89481H28.47V3.52473H27.7147V3.10503H29.6595V3.52473H28.9042V5.89481H28.9054ZM27.3601 5.89481H26.9258V3.10503H27.3601V5.89481ZM24.9194 5.89481H24.4851V3.52473H23.7298V3.10503H25.6746V3.52473H24.9194V5.89481ZM23.4549 5.89032H21.7896V3.10503H23.4549V3.52473H22.225V4.29007H23.3348V4.70528H22.225V5.47062H23.4549V5.89032ZM31.4314 5.24281C31.6256 5.43695 31.8612 5.53458 32.135 5.53458C32.4167 5.53458 32.6468 5.4392 32.8386 5.24281C33.0294 5.05204 33.1259 4.80179 33.1259 4.49992C33.1259 4.19805 33.0294 3.94668 32.8398 3.75703C32.6456 3.56289 32.4088 3.46526 32.1362 3.46526C31.8545 3.46526 31.6244 3.56064 31.4337 3.75703C31.2429 3.9478 31.1464 4.19805 31.1464 4.49992C31.1464 4.80179 31.2418 5.05316 31.4314 5.24281Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M30.6593 9.78999C29.5989 9.78999 28.7393 10.5946 28.7393 11.7045C28.7393 12.8042 29.6045 13.6189 30.6593 13.6189C31.7198 13.6189 32.5794 12.8087 32.5794 11.7045C32.5794 10.5946 31.7198 9.78999 30.6593 9.78999ZM30.6593 12.8603C30.0792 12.8603 29.5798 12.38 29.5798 11.7C29.5798 11.0098 30.0803 10.5396 30.6593 10.5396C31.2395 10.5396 31.7389 11.0098 31.7389 11.7C31.74 12.3845 31.2395 12.8603 30.6593 12.8603ZM26.4702 9.78999C25.4097 9.78999 24.5501 10.5946 24.5501 11.7045C24.5501 12.8042 25.4154 13.6189 26.4702 13.6189C27.5307 13.6189 28.3903 12.8087 28.3903 11.7045C28.3903 10.5946 27.5296 9.78999 26.4702 9.78999ZM26.4702 12.8603C25.89 12.8603 25.3907 12.38 25.3907 11.7C25.3907 11.0098 25.8912 10.5396 26.4702 10.5396C27.0504 10.5396 27.5498 11.0098 27.5498 11.7C27.5498 12.3845 27.0504 12.8603 26.4702 12.8603ZM21.4854 10.3747V11.1849H23.4302C23.3707 11.6394 23.2203 11.9749 22.9903 12.2049C22.7053 12.49 22.2654 12.7997 21.4899 12.7997C20.2948 12.7997 19.36 11.8346 19.36 10.6395C19.36 9.44435 20.2948 8.47926 21.4899 8.47926C22.1352 8.47926 22.6054 8.734 22.9544 9.05944L23.529 8.48487C23.0442 8.02029 22.3989 7.66455 21.4944 7.66455C19.8549 7.66455 18.4791 8.99996 18.4791 10.635C18.4791 12.2745 19.8538 13.6054 21.4944 13.6054C22.3798 13.6054 23.0442 13.3159 23.5694 12.7705C24.1046 12.2352 24.2741 11.48 24.2741 10.8707C24.2741 10.681 24.2595 10.5104 24.2292 10.3657H21.4843C21.4854 10.3646 21.4854 10.3747 21.4854 10.3747ZM41.8745 11.0053C41.714 10.5755 41.2293 9.7855 40.235 9.7855C39.2497 9.7855 38.4305 10.5609 38.4305 11.7C38.4305 12.775 39.2407 13.6144 40.3304 13.6144C41.2057 13.6144 41.7152 13.0791 41.925 12.7649L41.2753 12.3295C41.0598 12.6493 40.7602 12.8592 40.3349 12.8592C39.9051 12.8592 39.6043 12.6639 39.4046 12.279L41.9643 11.2185C41.9643 11.2197 41.8745 11.0053 41.8745 11.0053ZM39.2643 11.645C39.2441 10.9054 39.8389 10.5295 40.2642 10.5295C40.5997 10.5295 40.8791 10.6945 40.9745 10.9346L39.2643 11.645ZM37.1849 13.5H38.0254V7.87552H37.1849V13.5ZM35.8046 10.2153H35.7743C35.5846 9.98974 35.2244 9.7855 34.7643 9.7855C33.8093 9.7855 32.9295 10.626 32.9295 11.7056C32.9295 12.7806 33.8048 13.6111 34.7643 13.6111C35.2188 13.6111 35.5846 13.4057 35.7743 13.1756H35.8046V13.4506C35.8046 14.1811 35.4141 14.575 34.7845 14.575C34.2694 14.575 33.9496 14.2047 33.8194 13.895L33.0889 14.2002C33.2987 14.7052 33.8587 15.3303 34.7834 15.3303C35.7687 15.3303 36.6036 14.7501 36.6036 13.335V9.89996H35.8091V10.2153C35.8102 10.2153 35.8046 10.2153 35.8046 10.2153ZM34.8395 12.8603C34.2593 12.8603 33.7745 12.3755 33.7745 11.7056C33.7745 11.03 34.2593 10.5407 34.8395 10.5407C35.4141 10.5407 35.8596 11.0356 35.8596 11.7056C35.8652 12.3755 35.4152 12.8603 34.8395 12.8603ZM45.81 7.87552H43.8002V13.5H44.6407V11.37H45.8112C46.7415 11.37 47.656 10.6956 47.656 9.62502C47.656 8.55445 46.7448 7.87552 45.81 7.87552ZM45.8347 10.5845H44.6396V8.65433H45.8347C46.4643 8.65433 46.82 9.1739 46.82 9.61941C46.82 10.0604 46.4598 10.5845 45.8347 10.5845ZM51.0248 9.77989C50.4144 9.77989 49.7848 10.0503 49.5245 10.6395L50.2696 10.9492C50.4301 10.6395 50.7241 10.534 51.0349 10.534C51.4704 10.534 51.9103 10.7944 51.9204 11.2589V11.3184C51.77 11.2331 51.4401 11.103 51.0451 11.103C50.2404 11.103 49.4246 11.5429 49.4246 12.3677C49.4246 13.1229 50.0845 13.6077 50.8195 13.6077C51.384 13.6077 51.6948 13.353 51.8889 13.0578H51.9192V13.4932H52.7295V11.3386C52.7295 10.3354 51.9843 9.77989 51.0248 9.77989ZM50.9194 12.8603C50.6444 12.8603 50.2595 12.7256 50.2595 12.38C50.2595 11.9446 50.7398 11.7796 51.1494 11.7796C51.5197 11.7796 51.6948 11.8593 51.9147 11.9693C51.8541 12.4743 51.4277 12.8558 50.9194 12.8603ZM55.6853 9.89996L54.7202 12.3396H54.6899L53.69 9.89996H52.7856L54.2859 13.3103L53.4308 15.2057H54.3061L56.6145 9.89996H55.6853ZM48.1195 13.5H48.96V7.87552H48.1195V13.5Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.69524 3.39016C4.56507 3.53044 4.48988 3.74478 4.48988 4.02532V13.9758C4.48988 14.2564 4.56507 14.4707 4.69973 14.6054L4.73452 14.6357L10.3096 9.06061V8.93605L4.73003 3.35986L4.69524 3.39016Z"
          fill="url(#paint0_linear_612_64902)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.1645 10.9243L10.3051 9.06485V8.93467L12.1645 7.0752L12.2049 7.09988L14.4044 8.35001C15.034 8.70462 15.034 9.29041 14.4044 9.64951L12.2049 10.8996L12.1645 10.9243Z"
          fill="url(#paint1_linear_612_64902)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.2049 10.8999L10.3051 9L4.69524 14.6099C4.9006 14.8298 5.24511 14.8545 5.63002 14.6401L12.2049 10.8999Z"
          fill="url(#paint2_linear_612_64902)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.2049 7.1001L5.63002 3.36544C5.24511 3.14549 4.89947 3.17579 4.69524 3.39574L10.3051 8.99998L12.2049 7.1001Z"
          fill="url(#paint3_linear_612_64902)"
        />
        <path
          opacity="0.2"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.1645 10.8594L5.63452 14.5694C5.26981 14.7792 4.94438 14.7646 4.73453 14.5738L4.69974 14.6086L4.73453 14.6389C4.94438 14.8286 5.26981 14.8443 5.63452 14.6344L12.2094 10.8998L12.1645 10.8594Z"
          fill="black"
        />
        <path
          opacity="0.12"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.4044 9.58466L12.1589 10.8595L12.1993 10.8999L14.3988 9.64975C14.7142 9.4702 14.869 9.23454 14.869 9C14.8499 9.21546 14.6895 9.4197 14.4044 9.58466Z"
          fill="black"
        />
        <path
          opacity="0.25"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.63003 3.43053L14.4044 8.41532C14.6895 8.57579 14.8499 8.78564 14.8746 8.99998C14.8746 8.76544 14.7198 8.52978 14.4044 8.35023L5.63003 3.36544C5.00048 3.00522 4.48988 3.30597 4.48988 4.02529V4.09038C4.48988 3.36993 5.00048 3.0748 5.63003 3.43053Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_612_64902"
          x1="9.80949"
          y1="3.91797"
          x2="0.879233"
          y2="6.29744"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF" />
          <stop offset="0.00657" stopColor="#00A1FF" />
          <stop offset="0.2601" stopColor="#00BEFF" />
          <stop offset="0.5122" stopColor="#00D2FF" />
          <stop offset="0.7604" stopColor="#00DFFF" />
          <stop offset="1" stopColor="#00E3FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_612_64902"
          x1="15.2254"
          y1="8.99978"
          x2="4.33687"
          y2="8.99978"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE000" />
          <stop offset="0.4087" stopColor="#FFBD00" />
          <stop offset="0.7754" stopColor="#FFA500" />
          <stop offset="1" stopColor="#FF9C00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_612_64902"
          x1="11.1719"
          y1="10.0338"
          x2="4.00265"
          y2="22.1001"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF3A44" />
          <stop offset="1" stopColor="#C31162" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_612_64902"
          x1="3.28262"
          y1="0.0804317"
          x2="6.48109"
          y2="5.46944"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#32A071" />
          <stop offset="0.0685" stopColor="#2DA771" />
          <stop offset="0.4762" stopColor="#15CF74" />
          <stop offset="0.8009" stopColor="#06E775" />
          <stop offset="1" stopColor="#00F076" />
        </linearGradient>
        <clipPath id="clip0_612_64902">
          <rect width="61" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PlayStoreBadgeEn;
